/// <reference path="../../../typings/tsd.d.ts" />
module warsApp.directives {
    export interface IGisFieldMappingsScope extends angular.IScope {
        gisFieldMappings: Wars.Domain.Model.Gis.GisFieldMapping[];
        mapConfiguration: Wars.Domain.Model.Gis.MapConfiguration;
        query: any;
        addFieldMapping: any;
        save: any;
        removeField: any;
        currentGisDatastoreAttributes:any;
    }

    export class GisFieldMappings implements IDirective {
        public link($scope: IGisFieldMappingsScope, element: JQuery, attrs: ng.IAttributes) {
        }

        public templateUrl = "./app/views/directives/gis/gisFieldMappings.html";
        public restrict: string = "E";
        public controller = ["$scope", 'mapConfigurationService', GisFieldMappingsController];
        public controllerAs = "controller";
        public scope: any = {
            gisFieldMappings: "=",
            mapConfiguration: "=",
            query: "=",
            includedFields: "="
        };
    }

    export class GisFieldMappingsController {
        constructor(private $scope: IGisFieldMappingsScope, private mapConfigurationService: services.MapConfigurationService) {
            $scope.save = () => this.save();
            $scope.addFieldMapping = () => this.addFieldMapping();
            $scope.removeField = (f) => this.removeField(f);

            if ($scope.query.gisDatastoreQueryConfiguration) {
                this.setupGisDatastoreAttributes();
            }
        }

        private save() {
            this.mapConfigurationService.saveAllChanges();
        }

        private setupGisDatastoreAttributes() {
            this.$scope.currentGisDatastoreAttributes = [];
            if (this.$scope.query.gisDatastoreQueryConfiguration.gisDatastore) {
                for (let i = 1; i < 21; i++) {
                    if (this.$scope.query.gisDatastoreQueryConfiguration.gisDatastore['metadata' + i + 'PropertyName']) {
                        this.$scope.currentGisDatastoreAttributes.push({
                            name: this.$scope.query.gisDatastoreQueryConfiguration.gisDatastore['metadata' + i + 'PropertyName'],
                            index: i
                        });
                    }
                }
            }
        }

        private addFieldMapping() {
            let fieldMapping = this.mapConfigurationService.createQueryGridFieldMapping();

            this.$scope.gisFieldMappings.push(fieldMapping);
            this.save();
        }

        private removeField(field: Wars.Domain.Model.Gis.GisFieldMapping) {
            field.entityAspect.setDeleted();

            this.save();
        }
    }
}

warsApp.registerDirective('GisFieldMappings', []);
